// Browser-side loader for KareHero's Attendance Allowance question schema.
// Loads the 17 seed JSON files via import.meta.glob and flattens them with the
// shared pure logic in aaSchemaCore (also used by the dev-server extraction).

import {
  buildFieldIndex,
  buildSections,
  interpolate,
  isFieldActive,
  type FlatField,
  type FormSection,
  type RawQuestion,
} from './aaSchemaCore';

export { interpolate, isFieldActive };
export type { FlatField, FormSection };

function basename(path: string): string {
  return path
    .split('/')
    .pop()!
    .replace(/\.json$/, '');
}

const modules = import.meta.glob('../schema/*.json', { eager: true }) as Record<
  string,
  { default: RawQuestion[] }
>;

const files: Record<string, RawQuestion[]> = {};
for (const [path, mod] of Object.entries(modules)) {
  files[basename(path)] = mod.default ?? (mod as unknown as RawQuestion[]);
}

export const sections: FormSection[] = buildSections(files);

/** Flat index of every field by id (includes table columns). */
export const fieldsById: Record<string, FlatField> = buildFieldIndex(sections);
